package com.nnod.landing.web

import kotlinx.browser.window

actual fun getBrowserPathname(): String =
    window.location.pathname.ifBlank { "/" }

actual fun openDeepLink(url: String) {
    window.location.href = url
}

actual fun copyToClipboard(text: String) {
    try {
        window.navigator.clipboard.writeText(text)
    } catch (_: Throwable) {
        // Clipboard API unavailable (insecure context or unsupported browser)
    }
}
